var React = require('react');

function MyOrganizationIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.188 9.58c.642.244 1.25.559 1.812.935v2.586a6.98 6.98 0 0 0-4.07-2.04 8.08 8.08 0 0 0-.033-2.35 3.5 3.5 0 1 0-3.91-5.648 7.951 7.951 0 0 0-1.936-.798 5.5 5.5 0 1 1 8.136 7.315zm-18.09 1.681A7.015 7.015 0 0 0 0 14.392v-3.1a9.014 9.014 0 0 1 2.15-1.43A5.5 5.5 0 1 1 9.95 2.266a7.951 7.951 0 0 0-1.937.798A3.5 3.5 0 1 0 4.103 8.71a8.057 8.057 0 0 0-.004 2.551zM12 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm6-4a5.988 5.988 0 0 1-2.226 4.665A11.017 11.017 0 0 1 22.82 23h-2.042a9.003 9.003 0 0 0-17.554 0H1.181a11.017 11.017 0 0 1 7.045-8.335A6 6 0 1 1 18 10z","fill":"#fff"}));
}

MyOrganizationIcon.defaultProps = {"width":"24","height":"23","viewBox":"0 0 24 23","fill":"none"};

module.exports = MyOrganizationIcon;

MyOrganizationIcon.default = MyOrganizationIcon;
